module.exports = __webpack_public_path__ + "img/1.d9d37f7c.png";